import InfoLayout from "./InfoLayout";

function About() {
  return (
    <InfoLayout title="About the App">
      <p>
        <strong>Tabata Timer</strong> is a modern web fitness application designed
        to be as simple, versatile, modern, clear, and accessible from anywhere as possible.
      </p>

      <h2>Why Tabata Timer?</h2>
      <ul>
        <li>
          <strong>No installation, no registration:</strong> the app works directly in a regular
          web browser. It doesn’t take up phone memory and doesn’t need to be installed on other devices.
        </li>
        <li>
          <strong>Ideal for large screens:</strong> unlike mobile apps, Tabata Timer can be conveniently
          used on a monitor, laptop, or TV.
        </li>
        <li>
          <strong>Diverse exercise database:</strong> more than 30 exercises in the basic version,
          divided into categories: upper body, lower body, core, strength, cardio, bodyweight,
          jump rope, punching bag, and more.
        </li>
        <li>
          <strong>Individual difficulty:</strong> each exercise has assigned strength and cardio
          intensity. This makes it easy to build both light workouts and highly intense Tabata sessions.
        </li>
        <li>
          <strong>Charts and clarity:</strong> see how intensity changes throughout
          the workout. Every Tabata can be different – intense at the beginning, balanced, or
          gradually decreasing.
        </li>
        <li>
          <strong>Unlimited variations:</strong> by combining exercises, you can create millions
          of different sets.
        </li>
        <li>
          <strong>Simplicity and speed:</strong> no unnecessary thinking – just pick your
          exercises, start the timer, and train.
        </li>
        <li>
          <strong>Variety and motivation:</strong> the app keeps offering you new challenges and
          exercise mixes, so your training never gets boring.
        </li>
      </ul>

      <h2>What can the app do?</h2>
      <ul>
        <li>Select 8 exercises for your workout</li>
        <li>Track strength and cardio performance charts</li>
        <li>Export results to PDF</li>
      </ul>

      <h2>App Structure</h2>
      <ul>
        <li>
          <strong>Exercise selection:</strong> a database of exercises divided into categories,
          cardio and strength difficulty ratings, and charts for better clarity.
        </li>
        <li>
          <strong>Video ads:</strong> a dedicated page for playing video advertisements.
        </li>
        <li>
          <strong>Tabata Timer:</strong> an overview of the entire workout set, a large countdown,
          highlighted current exercise, and control buttons.
        </li>
        <li>
          <strong>Workout history:</strong> an overview of completed workouts with the option to
          add personal notes and export to PDF.
        </li>
      </ul>

      <p>
        Enjoy effective and fun training with the <strong>Tabata Timer</strong> – your
        guide to better results!
      </p>
    </InfoLayout>

  );
}

export default About;
